module.exports = __webpack_public_path__ + "hamburger-menu-normal.ea80c5bfc7c5e7ea4cc89d0a071acd3f.svg";